export function filterObjectId(obj, field) {
  let _obj = Object.assign({}, obj)
  if (field != null && _obj[field]) {
    _obj[field] = { id: _obj[field].id }
  }
  delete _obj["created"]
  delete _obj["updated"]
  return _obj
}

export function debounce(fn, wait = 1) {
  let timeout
  return function (...args) {
    clearTimeout(timeout)
    timeout = setTimeout(() => fn.call(this, ...args), wait)
  }
}
